<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.3631 27.7196C28.7992 24.9708 31 20.7424 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 20.7424 3.20083 24.9708 6.63686 27.7196M25.3631 27.7196C22.797 29.7724 19.5418 31 16 31C12.4582 31 9.20303 29.7724 6.63686 27.7196M25.3631 27.7196C22.6834 25.9312 19.4634 24.8887 16 24.8887C12.5365 24.8887 9.3166 25.9312 6.63686 27.7196M23.1111 14.2222C23.1111 18.1496 19.9274 21.3333 16 21.3333C12.0726 21.3333 8.88889 18.1496 8.88889 14.2222C8.88889 10.2949 12.0726 7.11111 16 7.11111C19.9274 7.11111 23.1111 10.2949 23.1111 14.2222Z"
      stroke="var(--icon-border-default)"
      stroke-width="1.6"
    />
  </svg>
</template>
